// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryQueryHook on POST /notification-settings/get-game.

import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type {
  typeNotificationSettingsGetGameBody,
  typeNotificationSettingsGetGameOutput200,
} from "../../sdk/notificationSettings/postNotificationSettingsGetGame";
import useCallSdk from "../../sdk-helpers/useCallSdk";

export function buildNotificationSettingsGetGameQueryKey(
  payload: typeNotificationSettingsGetGameBody,
): string[] {
  const queryKeySegments: string[] = [];
  queryKeySegments.push(`eventId:${JSON.stringify(payload.eventId)}`);
  return [
    "post:notificationSettings:notificationSettingsGetGame",
    "svc:notification-api",
    ...queryKeySegments,
  ];
}

type QueryOptions = Partial<
  UseQueryOptions<
    typeNotificationSettingsGetGameOutput200,
    unknown,
    typeNotificationSettingsGetGameOutput200,
    string[]
  >
> & {
  // Isolates two callers that query the same data for independent UI state
  // (e.g. a dropdown search vs a table both listing the same resource).
  queryKeyIdentifier?: string;
};

export default function useNotificationSettingsGetGame(
  payload: typeNotificationSettingsGetGameBody,
  options?: QueryOptions,
) {
  // No staleTime default here on purpose. Freshness is the consuming app's
  // decision and belongs in its QueryClient, in one place: a default set on the
  // hook would silently beat it for every screen. Pass one per call to override.
  const resolvedOptions = options ?? {};

  let queryKey = buildNotificationSettingsGetGameQueryKey(payload);
  if (resolvedOptions.queryKeyIdentifier) {
    queryKey = [...queryKey, resolvedOptions.queryKeyIdentifier];
  }

  const { callSdk } = useCallSdk();
  return useQuery({
    queryKey,
    queryFn: () => callSdk().postNotificationSettingsGetGame(payload),
    ...resolvedOptions,
  });
}
